import { http } from './config'

export default {

  getPermissionsByRole: (role_id) => {
    return http.get(`/permissions/${role_id}`)
  },

  getPermissionMenus: (role_id) => {
    return http.get(`/permissions/${role_id}/menus`)
  }
}
